// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import grey from "@material-ui/core/colors/grey"


// AMCHARTS
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
// import am4themes_animated from "@amcharts/amcharts4/themes/animated";

// UTILS
import * as moment from "moment"

// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<FlashIssueChart>")


// SETUP
// CHART
// am4core.useTheme(am4themes_animated)

const styles = theme => ({

    somestyle: {
        backgroundColor: grey[200]
    },
    
})


/*
const makeData_old = () => {
    let data = [];
    let visits = 10;
    let pointNum = 100
    let dataMin = 1
    let dataMax = 5
    let dataStepMax = 10
    let point

    for (let i = 1, dataStep = 0; i <= pointNum; i++) {
        log.debug("componentDidMount(): dataStep = ", dataStep)
        if(dataStep === 0) {
            point = Math.floor(Math.random() * (dataMax - dataMin + 1) + dataMin)
            visits = point
            dataStep++
        } else {
            if(dataStep <= dataStepMax)
                dataStep++
            else
                dataStep = 0
        }
        data.push({
            date: moment().subtract(pointNum-i, "days").format("MM-DD-YYYY"),
            name: "name" + i,
            value: visits
        })
    }

    log.debug("makeData(): data = ", data)

    return data
}


const makeData_old1 = () => {

    let data = [{
        "date": moment().subtract(0, "days").format("MM-DD-YYYY"),
        "value": 90
    }, {
        "date": moment().subtract(1, "days").format("MM-DD-YYYY"),
        "value": 102
    }, {
        "date": moment().subtract(2, "days").format("MM-DD-YYYY"),
        "value": 65
    }, {
        "date": moment().subtract(3, "days").format("MM-DD-YYYY"),
        "value": 62
    }, {
        "date": moment().subtract(4, "days").format("MM-DD-YYYY"),
        "value": 55
    }, {
        "date": moment().subtract(5, "days").format("MM-DD-YYYY"),
        "value": 81
    }];

    return data
}

const makeData_old2 = () => {

    const pointNum = 6
    const dataMin = 55
    const dataMax = 102

    let data = []
    
    for (let i = 0, point; i < pointNum; i++) {
        point = Math.floor(Math.random() * (dataMax - dataMin + 1) + dataMin)
        log.debug("makeData(): point =", point)
        data.push({
            "date": moment().subtract(i, "days").format("MM-DD-YYYY"),
            "value": point
        })
    }
    
    let data_old = [{
        "date": moment().subtract(0, "days").format("MM-DD-YYYY"),
        "value": 90
    }, {
        "date": moment().subtract(1, "days").format("MM-DD-YYYY"),
        "value": 102
    }, {
        "date": moment().subtract(2, "days").format("MM-DD-YYYY"),
        "value": 65
    }, {
        "date": moment().subtract(3, "days").format("MM-DD-YYYY"),
        "value": 62
    }, {
        "date": moment().subtract(4, "days").format("MM-DD-YYYY"),
        "value": 55
    }, {
        "date": moment().subtract(5, "days").format("MM-DD-YYYY"),
        "value": 81
    }];

    return data
}
*/

const makeData = () => {

    const pointNum = 6
    const dataMin = 0
    const dataMax = 5

    let data = []
    
    for (let i = 0, point; i < pointNum; i++) {
        point = Math.floor(Math.random() * (dataMax - dataMin + 1) + dataMin)
        log.debug("makeData(): point =", point)
        data.push({
            "date": moment().subtract(i, "weeks").format("MM-DD-YYYY"),
            "value": point
        })
    }

    return data
}


class FlashIssueChart extends Component {
    constructor(props){
        super(props)

        log.debug("constructor(): we supposed to do stuff here now :)")
    }

    state = {
        data: makeData(),
    }

    componentDidMount_works() {
        let data = this.state.data

        log.debug("componentDidMount(): data =", data)

        // make chart
        let chart = am4core.create("chartDiv", am4charts.XYChart)
        chart.data = data

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;
        dateAxis.title.text = "title text" 

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.renderer.minWidth = 35;
        // valueAxis.title.text = "Importance" // remove text

        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.dateX = "date";
        series.dataFields.valueY = "value";

//        series.tooltipText = "{valueY.value}"
//        chart.cursor = new am4charts.XYCursor()

        this.chart = chart
        
    }


    componentDidMount() {
        let data = this.state.data

        log.debug("componentDidMount(): data =", data)
        // weird attributes
        // chart.paddingRight = 20;
        // valueAxis.renderer.minWidth = 35
        //  series.stroke = am4core.color("#ff0000"); // red
        // dateAxis.renderer.minGridDistance = 50;
        // dateAxis.renderer.grid.template.location = 0.5;
        // dateAxis.startLocation = 0.5;
        // dateAxis.endLocation = 0.5;
        // grid count:
        // chart.categoryAxis.autoGridCount = false;
        // chart.categoryAxis.gridCount = 10;
        
        // make chart
        let chart = am4core.create("chartDiv", am4charts.XYChart)
        chart.data = data

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        // this takes out the vertical lines, as opposed to 0
        // dateAxis.renderer.grid.template.location = 0.5; // puts left and right vert lines
        // dateAxis.renderer.grid.template.location = 100 // adds and removes vertical lines
        // dateAxis.title.text = "title text"
        dateAxis.renderer.grid.template.location = 0.5
        dateAxis.renderer.minGridDistance = 20 // how many items show up on x grid
        dateAxis.renderer.grid.template.disabled = true // disable for now
        dateAxis.renderer.labels.template.fillOpacity = 0 // remove axis labels
        dateAxis.renderer.inside = true // make the chart as tight as possible

        // dateAxis.autoGridCount = false;
        // dateAxis.gridCount = 0;
        
        //        dateAxis.startLocation = 0.5
        dateAxis.startLocation = -1 // cuts of the left bullet, making it look like it's coming from infinite
        dateAxis.endLocation = 2
        dateAxis.renderer.maxLabelPosition = 0.99;
        dateAxis.renderer.labels.template.dy = 12

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        // yes, this works :)
        valueAxis.strictMinMax = true
        valueAxis.min = -2
        valueAxis.max = 8
        // valueAxis.tooltip.disabled = true
        // valueAxis.title.text = "Importance--" // remove text
        valueAxis.renderer.minWidth = 0 // this is the padding between text and the actual chart
        valueAxis.renderer.minGridDistance = 13 // yes, this is how much
//        valueAxis.renderer.labels.template.fill = am4core.color("#A0CA92");
        valueAxis.renderer.labels.template.fillOpacity = 0 // remove axis labels
        valueAxis.renderer.inside = true;
//        valueAxis.renderer.labels.template.fontSize = 20;

        
        let series = chart.series.push(new am4charts.LineSeries())
        series.dataFields.dateX = "date"
        series.dataFields.valueY = "value"
        // line attributes
        series.strokeWidth = 3 // 3px
        // series.strokeOpacity = 0.5
        series.tensionX = 0.9 // 1 angle, smaller smoother
        // series.stroke = am4core.color("#94672B"); // brown
        series.stroke = am4core.color("#42A5F5"); // brown
        series.minBulletDistance = 1 // space out the bullets


        // bullets
        let circleBullet = series.bullets.push(new am4charts.CircleBullet())

        // this actually works 'cause we return object that we can configure
        circleBullet.circle.radius = 10
        //bullet.height = 20
        //bullet.horizontalCenter = "middle";
        //bullet.verticalCenter = "middle";
        //        circleBullet.stroke = am4core.color("#94672B"); // brown
        circleBullet.stroke = am4core.color("#3484c4"); // dark blue border
        circleBullet.fill = am4core.color("#42A5F5"); // blue
        circleBullet.fillOpacity = 1
        circleBullet.strokeWidth = 2
        circleBullet.strokeOpacity = 1

        let labelBullet = series.bullets.push(new am4charts.LabelBullet());
        labelBullet.label.dy = 1
        labelBullet.label.text = "{value}";
        labelBullet.label.fill = am4core.color("#FFFFFF"); // white
        labelBullet.label.background.fill = am4core.color("#42A5F5"); // blue

        log.debug("componentDidMount(): labelBullet.label =",labelBullet.label)
        
        //let shadow = new am4core.DropShadowFilter();
        //shadow.dx = 2;
        //shadow.dy = 2;
        //bullet.filters.push(shadow);
        
        // chart formatting

        let title = chart.titles.create();
        title.text = this.props.title;
        title.fontSize = 15;
        title.fontWeight = "bold"
        title.marginTop = 10
        title.marginBottom = 30

        let label = chart.chartContainer.createChild(am4core.Label);
        label.fontSize = 13
        label.fontWeight = "bold"
        label.marginTop = 15;
        label.text = "Importance in Last 6 Weeks (0 to 5)";
        label.align = "center";

        // chart.background.fill = am4core.color("#CCFF99"); // green
        chart.background.fill = am4core.color("#FFFFFF"); // white background
        
        chart.paddingRight = 30 // this actually opens up sept 07, cuts it off otherwise
        this.chart = chart
        
    }
    

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    handleClick = () => {
        log.debug("handleClick()")
        this.setState({data: makeData()})
    }

    render() {
        const { classes } = this.props

        log.debug("render(): classes =", classes)
        log.debug("render(): state =", this.state)

        return (
            <div id="chartDiv"
                 style={{marginLeft: 0, width: "100%", height: "200px"}}
                 onClick={this.handleClick}
            >
              
            </div>
        )
    }
}


FlashIssueChart.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {name: "FlashIssueChart"})(FlashIssueChart)
